import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IUpdateOfficeInfoApiPayload,
  TUpdateOfficeInfoApiResponse,
} from '../types/UpdateOffice.api';
import { withOfficeOverride, type IOfficeOverrideOptions } from './officeOverride';

export const updateOfficeInfo = async (
  payload: IUpdateOfficeInfoApiPayload,
  options?: IOfficeOverrideOptions,
): Promise<TUpdateOfficeInfoApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<TUpdateOfficeInfoApiResponse>(
    '/users',
    payload,
    { headers: withOfficeOverride(headers, options) },
  );
  return data;
};
